module.exports = __webpack_public_path__ + "img/hpCasino.fe762418.png";